import { Parser } from "@siteimprove/alfa-parser";
import { Selective } from "@siteimprove/alfa-selective";
import { Circle } from "./circle.js";
import { Ellipse } from "./ellipse.js";
import { Extent } from "./extent.js";
const { either } = Parser;
/**
 * Radial gradient shapes
 *
 * @remarks
 * The syntax inside a radial-gradient() function is significantly different
 * from the basic shape functions circle() and ellipse(), so we cannot easily
 * reuse the code.
 *
 * @internal
 */
export var Shape;
(function (Shape) {
    function partiallyResolve(resolver) {
        return (value) => Selective.of(value)
            .if(Ellipse.isEllipse, (ellipse) => ellipse.partiallyResolve(resolver))
            .else((value) => value.resolve(resolver))
            .get();
    }
    Shape.partiallyResolve = partiallyResolve;
    Shape.parse = either(Ellipse.parse, Circle.parse, Extent.parse);
})(Shape || (Shape = {}));
//# sourceMappingURL=shape.js.map